var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "app-container view-container",
      attrs: {
        "label-position": "top",
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            " " + _vm._s(_vm.$t("CustomerFunction.common.ModifyReturn")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.tryCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      [
        _c(
          "el-row",
          { attrs: { gutter: 10 } },
          [
            _c(
              "el-col",
              { attrs: { span: "6" } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("billingPage.CustomerName"),
                      prop: "clientCode",
                    },
                  },
                  [
                    _c("BjSelectLov", {
                      attrs: {
                        "option-list": _vm.clientCodeList,
                        disabled: true,
                      },
                      model: {
                        value: _vm.form.clientCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "clientCode", $$v)
                        },
                        expression: "form.clientCode",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: "6" } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CustomerFunction.common.logisticsNo"),
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.logisticsNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "logisticsNumber", $$v)
                        },
                        expression: "form.logisticsNumber",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: "6" } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CustomerFunction.common.associatedCode"),
                      prop: "",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t("chooseText"),
                        clearable: true,
                      },
                      on: {
                        input: _vm.handleInput,
                        focus: _vm.handleShowFnForDialogOrderList,
                      },
                      model: {
                        value: _vm.form.associatedCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "associatedCode", $$v)
                        },
                        expression: "form.associatedCode",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: "6" } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessAfterCsgReturn.main.thirdOrder"),
                      prop: "",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t("inputText"),
                        clearable: true,
                      },
                      model: {
                        value: _vm.form.platformNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "platformNo", $$v)
                        },
                        expression: "form.platformNo",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      _c(
        "div",
        { staticClass: "bj-row mt20" },
        [
          _c(
            "BjDivider",
            [
              _vm._v(
                _vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Product")) + " "
              ),
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleShowFnForDialogSkuList },
                  },
                  [_vm._v(_vm._s(_vm.$t("BusinessAfterCsgReturn.table.add")))]
                ),
              ],
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "bj-col bj-col-24",
              staticStyle: { "border-left": "none" },
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.form.applySkuList,
                    border: "",
                    script: "",
                    "max-height": "600px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("table.countText"),
                      type: "index",
                      width: "55",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "standardSkuCode",
                      label: "SKU",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "barCode",
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Barcode"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            _vm._v(
                              " " + _vm._s(_vm.$t("UploadTotalText")) + " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjInputNumber", {
                              staticClass: "full-width",
                              attrs: { clearable: "", controls: false },
                              model: {
                                value: row.returnTotal,
                                callback: function ($$v) {
                                  _vm.$set(row, "returnTotal", $$v)
                                },
                                expression: "row.returnTotal",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("CustomerFunction.table.GoodQuality")
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjSelectLov", {
                              attrs: {
                                disabled: !_vm.$store.getters.cusId,
                                "option-list": _vm.CSG_RETURN_LIST_ADMIN_STATUS,
                                clearable: false,
                              },
                              model: {
                                value: row.nonDefectiveHandling,
                                callback: function ($$v) {
                                  _vm.$set(row, "nonDefectiveHandling", $$v)
                                },
                                expression: "row.nonDefectiveHandling",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("CustomerFunction.table.HandlingOf")
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjSelectLov", {
                              attrs: {
                                disabled: !_vm.$store.getters.cusId,
                                "option-list": _vm.CSG_RETURN_LIST_ADMIN_STATUS,
                                clearable: false,
                              },
                              model: {
                                value: row.defectiveHandling,
                                callback: function ($$v) {
                                  _vm.$set(row, "defectiveHandling", $$v)
                                },
                                expression: "row.defectiveHandling",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("table.operationText"),
                      fixed: "right",
                      align: "center",
                      width: "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var $index = ref.$index
                          return [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.onDelete($index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("delText")))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "BjDialogOrderList",
        attrs: {
          width: "80%",
          config: _vm.$BjDialogListConfig.thirdOrderDefault(
            _vm.$t("AddAThirdPartyAfterSalesOrder.associated"),
            { defaultQuery: { totalOrderStatus: [5], cusId: this.form.cusId } }
          ),
          "tag-name": "outerOrderNo",
        },
        on: { confirm: _vm.confirmForDialogOrderList },
      }),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: {
          colSpan: 8,
          config: _vm.$BjDialogListConfig.skuDefault("SelectSKUText", {
            defaultQuery: _vm.defaultQuery,
            columns: _vm.columns,
            search: _vm.search,
            actionApi: _vm.actionApi,
          }),
          multiple: "",
        },
        on: { confirm: _vm.onAddDialogConfirm },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }